
      
   <template>
      <div>
         <div class="div_home">
    <!-- main div -->
    <div class="main_rules">
        <!-- image div -->
        <div class="img_rules" v-if="data.image">
            <img :src="data.image">
        </div>
        <!-- HTML EDITOR div -->
        <div class="box_rules">
            <div class="ui violet segment text_rules" v-html="parseHtml(data.text)"></div>
        </div>
    </div>
</div> 
      </div>
   </template>
   
   <script>
      
      export default {
  props: {
    context: Object,
  },
  data() {
    return {
     data: {},
    };
  },
  async created() {
    this.data = await getStaticPageInfo('rules');
  },
  methods: {
    parseHtml(html){
      return sanitizeHtml(html)
    }
  },
  components: {},
}; 
   </script>

   <style scoped>
      .div_home {
  padding: 2% 4% 2%;
}
.div_home .main_rules {
  text-align: justify;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100% !important;
  align-content: center;
  padding: 0px 8%;
  border-radius: 12px;
}
.div_home .main_rules .img_rules img {
  max-height: 300px;
  max-width: 100%;
}
.div_home .main_rules .box_rules {
  width: 90%;
  margin-block-start: 5%;
}
.div_home .main_rules .box_rules .text_rules {
  border-radius: 12px !important;
  padding: 5%;
}

@media only screen and (min-width: 600px) and (max-width: 950px) {
  .main_rules {
    padding: 3% !important;
  }
}
@media only screen and (min-width: 450px) and (max-width: 600px) {
  .div_home {
    padding: 1% !important;
  }
  .div_home .main_rules {
    padding: 1.5% !important;
  }
  .div_home .main_rules .text_rules {
    width: 100% !important;
  }
}
@media only screen and (max-width: 450px) {
  .div_home {
    padding: 0.5% !important;
  }
  .div_home .main_rules {
    padding: 1% !important;
    padding-top: 2% !important;
  }
  .div_home .main_rules .img_rules {
    width: 250px !important;
  }
  .div_home .main_rules .img_rules img {
    height: 250px !important;
  }
  .div_home .main_rules .text_rules {
    width: 100% !important;
  }
}

   </style>
    
  
   